import(/* webpackMode: "eager" */ "/vercel/path0/platforms/api/apps/dashboard/app/auth/sign-up/[[...sign-up]]/page.tsx");
